import React from 'react';
import { styled } from 'styled-components';

import { Flex } from '@rover/kibble/core';
import MQ from '@rover/kibble/styles/MediaQuery';

import { SkillsAndBehaviorSlugsDictionary } from '../../utils/params';
import { FilterSectionLayout } from '../layouts';

import { TrainingNeedsForm } from './TrainingNeedsForm/TrainingNeedsForm';
import FilterForm from './FilterForm';
import { FormState } from './filterFormState';
import StaticServiceTypeFilter from './StaticServiceTypeFilter';

const ServiceTypeFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  ${MQ.XS_DOWN.toString()} {
    display: none;
  }
`;

export type FilterSectionProps = {
  onSubmit: (formData: FormState) => void;
  query: Partial<FormState>;
  selectedSkillsAndBehaviors: SkillsAndBehaviorSlugsDictionary;
  updateSkillsAndBehaviors: (skillsAndBehaviors: SkillsAndBehaviorSlugsDictionary) => void;
};

export default function FilterSection({
  onSubmit,
  query,
  selectedSkillsAndBehaviors,
  updateSkillsAndBehaviors,
}: FilterSectionProps): JSX.Element {
  return (
    <FilterSectionLayout stickyTopMobile="0">
      <Flex flexDirection="column">
        <ServiceTypeFilterWrapper>
          <StaticServiceTypeFilter />
        </ServiceTypeFilterWrapper>
        <Flex flexDirection="column" sx={{ gap: ['4x', '8x'] }}>
          <FilterForm onSubmit={onSubmit} query={query} />
          <TrainingNeedsForm
            selectedSkillsAndBehaviors={selectedSkillsAndBehaviors}
            updateSkillsAndBehaviors={updateSkillsAndBehaviors}
          />
        </Flex>
      </Flex>
    </FilterSectionLayout>
  );
}
